module.exports = __webpack_public_path__ + "static/assets/ebd8ef63a4168e7be168f82dcee63a65.gif";